<div class="middle-box text-center loginscreen  animated fadeInDown gary-bg">
  <div>
    <div class="m-b-md logo-name" aria-hidden="true">
      <!-- img alt="image" class="img-container" src="img/logo.png" -->
    </div>
    <p>
      <strong>{{ 'LoginView.welcome' | translate }}</strong>
    </p>
    <p>{{ 'LoginView.cert-description' | translate }}.</p>
    <!--
      <span *ngIf="authService.redirectTo"> a {{authService.redirectTo}}</span>
    -->
    <form #f="ngForm" (ngSubmit)="onSubmit()" class="m-t">
      <div
        class="login-spiner"
        [style.visibility]="show_spin"
        aria-hidden="true"
      >
        <div class="sk-spinner sk-spinner-three-bounce" aria-hidden="true">
          <div class="sk-bounce1" aria-hidden="true"></div>
          <div class="sk-bounce2" aria-hidden="true"></div>
          <div class="sk-bounce3" aria-hidden="true"></div>
        </div>
      </div>
      <div class="form-group" *ngIf="modoMesaEnabled">
        <p-checkbox
          [(ngModel)]="modoAcceso"
          label="{{ 'LoginView.modoMesa' | translate }}"
          binary="true"
          [ngModelOptions]="{ standalone: true }"
        ></p-checkbox>
      </div>
      <div *ngIf="errorMsg" class="form-group">
        <span class="text-danger">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          {{ errorMsg }}</span
        >
      </div>
      <button
        tabindex="3"
        type="submit"
        class="btn btn-primary block full-width m-b btn-lg"
      >
        {{ 'LoginView.access-cert' | translate }}
      </button>
    </form>
    <p>{{ 'LoginView.plyca' | translate }}</p>
  </div>
</div>
